<template>
  <div class="custom-select" :tabindex="tabindex">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ selectedValue }}
    </div>

    <div class="items" :class="{ selectHide: looksForValue }">
      <span id="contacts-search" @click="searchValue = true">
        <input
          placeholder="Search housemate"
          type="text"
          id="contacts-search-input"
          name="lname"
          v-model="searchInput"
        />
        <img id="contacts-search-img" src="../../../assets/search.svg" />
      </span>

      <div>
        <slot name="custom-render"></slot>
      </div>

      <div
        class="options"
        v-for="(option, i) of filteredValues"
        :key="i"
        @click="
          selected = option.label
          open = false
          searchValue = false
          $emit('input', option)
        "
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    default: {
      type: String,
      required: false,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      selected: null,
      open: false,
      searchInput: null,
      searchValue: false,
      closeTab: false
    }
  },
  methods: {},

  computed: {
    looksForValue() {
      let flag

      //
      if (!this.open && this.searchValue == false) flag = true
      else flag = false

      return flag
    },

    selectedValue() {
      return this.selected ? this.selected : this.default
    },
    filteredValues() {
      if (!this.searchInput) return this.options
      const regex = new RegExp(this.searchInput, 'gi')
      const filtered = []
      for (const thing of this.options) {
        if (thing.label.toLowerCase().match(regex)) {
          filtered.push(thing)
        }
      }
      if (filtered.length < 1) return this.options
      return filtered
    }
  }
}
</script>

<style scoped>
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  border: 1px solid #cbd4dc;
  border-radius: 6px;
  padding: 9px 14px;
  max-height: 40px;
  height: 40px;
  box-sizing: border-box !important;
}

.custom-select.error {
  border: 1px solid red !important;
}

.custom-select .selected {
  background-color: #ffffff;
  border-radius: 6px;
  padding-left: 0.3em;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 2em;
}

.custom-select .selected:after {
  position: absolute;
  content: '';
  top: 17px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #000 transparent transparent transparent;
}

.custom-select .items {
  border-radius: 0px 0px 6px 6px;
  overflow: auto;
  border-right: 1px solid #cbd4dc;
  border-left: 1px solid #cbd4dc;
  border-bottom: 1px solid #cbd4dc;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 13px;
  max-height: 200px;
}

.custom-select .items .options {
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  border-bottom: solid 1px #cbd4dc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px !important;
  line-height: 40px;
}

.custom-select .items div:hover {
  background-color: #cbd4dc;
}

.selectHide {
  display: none;
}

#contacts-search {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
#contacts-search-input {
  width: 100%;
  border-width: 1px;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  padding-left: 16px;
  margin-right: 4px;
}
#contacts-search-img {
  height: 25px;
  width: 25px;
  position: absolute;
  right: 16px;
}
</style>
